import { render, staticRenderFns } from "./NiveisAcessoUpdate.vue?vue&type=template&id=7ab28c50&"
import script from "./NiveisAcessoUpdate.vue?vue&type=script&lang=js&"
export * from "./NiveisAcessoUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports